// authorization.service.ts
import { Injectable } from '@angular/core';
import { ContextUserService } from './context-user.service';
import { UsuariosService } from '../centralization/usuarios.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private permisos: number[] = [1000];
  private permisosByProfile = new Map<number, number[]>();

  constructor(private readonly _contextService: ContextUserService,private readonly usuariosService: UsuariosService) {}

  /**
   * Carga los permisos para el usuario autenticado.
   */
  // async cargarPermisos(): Promise<void> {
  //   try {
  //     await this._contextService.setContextUser();
  //     const user = this._contextService.getUser;

  //     if (!user) {
  //       throw new Error('No se encontró el rol del usuario');
  //     }

  //     // 1000 - Acceso mínimo por usuario al home
  //     const permisosUser: number[] = [1000];
  //     this.permisosByProfile.clear();

  //     if (user.user.usActive == 1) {
  //       user.profiles.forEach((profile: any) => {
  //         const prId = Number(profile.prId);
  //         const peIds =
  //           (profile.permissions ?? [])
  //             .map((p: any) => Number(p.peId))
  //             .filter((n: number) => Number.isFinite(n)) ?? [];

  //         // mantener el comportamiento anterior (todos los permisos) para debugging/compat
  //         peIds.forEach((id: number) => permisosUser.push(id));

  //         this.permisosByProfile.set(prId, Array.from(new Set([1000, ...peIds])));
  //       });
  //     }

  //     // Por defecto: permisos del perfil activo (si existe), si no, todos.
  //     const activePrId = this._contextService.activeProfileId;
  //     if (activePrId != null && this.permisosByProfile.has(activePrId)) {
  //       this.permisos = this.permisosByProfile.get(activePrId) ?? [1000];
  //     } else {
  //       this.permisos = Array.from(new Set(permisosUser));
  //     }
  //     console.log('permisos (activos)', this.permisos);
  //   } catch (error) {
  //     console.error('Error al cargar los permisos:', error);
  //     return Promise.reject(error);
  //   }
  // }
    cargarPermisos(): Promise<void> {
    let rolId: number | null = null; 
    const currentUser = localStorage.getItem('currentUserCr');
    if (currentUser) {
        const parsedUser = JSON.parse(currentUser);
        rolId = parsedUser.us_rol;    
    }
    console.log('us_rol',rolId)
    if (!rolId) {
      return Promise.reject('No se encontró el rol del usuario');
    }
    return new Promise((resolve, reject) => {
        this.usuariosService.obtenerPermisosPorRol(rolId).subscribe({
          next: (response) => {
            this.permisos = response;
            console.log('permisos',this.permisos)
            resolve();
          },
          error: (error) => {
            console.error('Error al cargar permisos:', error);
            reject(error);
          }
        });
      });
      
  }

  /**
   * Actualiza permisos activos según perfil preferido/activo.
   * No hace request: usa el contexto ya cargado.
   */
  setPerfilActivo(prId: number | null): void {
    if (prId == null) {
      this.permisos = [1000];
      return;
    }
    const next = this.permisosByProfile.get(prId);
    this.permisos = next?.length ? next : [1000];
  }

  /**
   * Verifica si el usuario tiene un permiso específico por ID.
   * @param permisoId - ID del permiso que se desea verificar
   * @returns true si el usuario tiene el permiso, de lo contrario false
   */
  tienePermiso(permisoId: number): boolean {
    console.log('verificando permiso', permisoId, 'en', this.permisos);
    return this.permisos.includes(permisoId);
  }
}
